module.exports = __webpack_public_path__ + "media/images/lig/uxu-gallery/gallery-item-2-d63c7c8a016db993a34de83ed0526c56.jpg";